
import Vue, { PropType } from 'vue'

import JFileInputImage from '@/ui/controls/JFileInputImage.vue'

import { id } from '@/types/models'
import JFileContainer from '@/models/JFileContainer'

export default Vue.extend({
  components: {
    JFileInputImage,
  },
  props: {
    gardenId: String,
    plantIds: Array as PropType<id[]>,
  },
  data: () => ({
    files: [] as JFileContainer[],
    note: '',

    submitting: false,
  }),
  computed: {
    plants() {
      return this.$store.getters['gardens/plants/inGarden'](this.gardenId)
    },
  },
  methods: {
    onPlantChange(e: id[]): void {
      this.$emit('input', e)
    },
    isInvalid(): string | void {
      if (this.plantIds.length < 1) return 'select plant(s)'
      if (this.files.length < 1) return 'select file(s)'
    },
    submit(): void {
      // validate form
      const isInvalid = this.isInvalid()
      if (isInvalid) {
        this.$store.dispatch('snackbars/error', isInvalid)
        throw Error(isInvalid)
      }

      this.submitting = true

      this.uploadFiles(this.files)
        // .then((uploads: Array<JFileContainer>) => console.log(uploads))
        .then((uploads: Array<JFileContainer>) =>
          this.$store.dispatch(
            'snackbars/add',
            `Uploaded ${uploads.length} file(s)`
          )
        )
        .then(() => this.$emit('close'))
        .catch((err) => this.$store.dispatch('snackbars/error', err.message))
        .finally(() => (this.submitting = false))
    },
    uploadFiles(files: Array<JFileContainer>) {
      return Promise.all(
        files.map((file: JFileContainer) =>
          this.$store.dispatch('gardens/images/add', {
            file,
            gardenId: this.gardenId,
            refs: this.plantIds.map((plantId: id) =>
              ['gardens', this.gardenId, 'plants', plantId].join('/')
            ),
            note: this.note,
          })
        )
      )
    },

    // uploadFiles(files: Array<JFileContainer>) {
    //   return Promise.all(
    //     files.map((f: JFileContainer) => {
    //       // get new doc for image
    //       const newDocRef = db.collection('images').doc();

    //       const newDocData = {
    //         isNew: true,
    //         note: this.note || null,
    //         refs: this.plantIds.map((plantId: id) => `plants/${plantId}`)
    //       }

    //       return uploadFileToFirestore(
    //         f,
    //         newDocRef.withConverter(Image.firestoreConverter()),
    //         newDocData,
    //         storage.ref().child(BASE_STORAGE_PATH).child(newDocRef.id),
    //         DEFAULT_METADATA,
    //       )
    //     })
    //   )
    // },

    // uploadFile() {
    //   // Add a new document with a generated id.
    //   const newDocRef = db.collection('images').doc();
    //   console.log(newDocRef.id)
    //   // console.log(this.$refs.uploader.uploadFile)
    // },
    //   onUploaded() {
    //     storage.ref().child(this.path())
    //       .getDownloadURL()
    //       .then((avatar: string) => {
    //         console.log(avatar)
    //         const url = new URL(avatar)
    //         const { hash, host, hostname, href, origin, password, pathname, port, protocol, search, searchParams, username } = url
    //         const urlJSON = {
    //           hash, host, hostname, href, origin, password, pathname, port, protocol, search, searchParams, username
    //         }
    //         console.log(urlJSON)
    //         return avatar
    //       })
    //       .then((avatar: string) => this.$store.dispatch('plants/update', { id: this.plant.id, updates: { avatar } }))
    //       .then(() => this.$store.dispatch('snackbars/add', `Uploaded avatar for ${this.plant.name}`))
    //       .catch((err: Error) => this.$store.dispatch('snackbars/error', err.message))
    //   },
  },
})
